import { ClubSearchSelect } from '~/pages/club/components/club-search-select';
import { DistrictSelect } from '~/pages/district/components/district-select';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { querySchema } from '../query-schema';

export function LifterListFilter() {
  const { register, setValue, values } = useFilterForm(querySchema.parse);

  return (
    <Table.Bar>
      <Table.Search {...register('search')} placeholder="Sök på namn..." aria-label="Sök" />

      <Table.Filter>
        <Table.FilterSection label="Distrikt">
          <DistrictSelect {...register('district')} />
        </Table.FilterSection>

        <Table.FilterSection label="Förening">
          <ClubSearchSelect
            value={values.club ? [values.clubName, values.club] : undefined}
            query={{ district__id: values.district }}
            placeholder="Sök på förening..."
            onChange={v => {
              setValue('club', v ? (v[1] as string) : undefined);
              setValue('clubName', v ? v[0] : undefined);
            }}
          />
        </Table.FilterSection>
      </Table.Filter>
    </Table.Bar>
  );
}
